// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.i_wBNb1ia80e7xh5BIcx {
  width: 100%;
  background-color: var(--top-block-background);
}

.EaDF20f8yg3aath0KQVL {
  max-width: 90rem;
  padding: 3rem 4rem;
  margin: 0 auto;
}

.V_9Dg7Vo_BOLIKJjQaof {
  display: flex;
}

.YT88as1ms5dCjRtxFdpB {
  width: 50%;
  padding-right: 6.25rem;
}

.Vc8yfPcUlAejSxUY8Hol {
  margin-top: 3rem;
  font-weight: 900;
  font-size: 3rem;
  line-height: 3.25rem;
}

.XdEQwWsSTgWXWA1bGGwC {
  color: var(--top-block-contrast-font-color);
  margin: 1.5rem 0;
}

.SSbXmq1B8F5wSohlzaPV {
  margin-top: 1.5rem;
}

.mML8Ohzo58mv5uaARftT {
  width: 50%;
  margin-top: 3.4375rem;
}

.qh3Ey0A5HiVagxeeawH3 {
  width: 39.75rem;
  height: 22.3125rem;
  border-radius: var(--panel-border-radius);
  object-fit: cover;
  box-shadow: 0 0.25rem 0.75rem var(--black-012);
}

@media only screen and
  (min-width: 1024px) and
  (max-width: 1279px) {
  .EaDF20f8yg3aath0KQVL {
    padding: 2rem 3rem;
  }

  .qh3Ey0A5HiVagxeeawH3 {
    width: 100%;
  }

  .Vc8yfPcUlAejSxUY8Hol {
    font-weight: 800;
    font-size: 1.75rem;
    line-height: 2rem;
  }
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .EaDF20f8yg3aath0KQVL {
    padding: 1.5rem 2rem 1.5rem;
  }

  .V_9Dg7Vo_BOLIKJjQaof {
    display: flex;
    flex-direction: column-reverse;
  }

  .Vc8yfPcUlAejSxUY8Hol {
    margin-top: 0;
    font-weight: 900;
    font-size: 2.375rem;
    line-height: 2.625rem;
  }

  .YT88as1ms5dCjRtxFdpB {
    width: 100%;
    padding: 0;
    margin-bottom: 1.5rem;
  }

  .mML8Ohzo58mv5uaARftT {
    width: 100%;
    margin: 2.1875rem 0;
  }

  .qh3Ey0A5HiVagxeeawH3 {
    width: 100%;
    height: 18.875rem;
  }
}

@media only screen and
  (max-width: 639px) {
  .EaDF20f8yg3aath0KQVL {
    padding: 1.5rem 1rem 1.5rem;
  }

  .V_9Dg7Vo_BOLIKJjQaof {
    display: flex;
    flex-direction: column-reverse;
  }

  .Vc8yfPcUlAejSxUY8Hol {
    margin-top: 0;
    font-weight: 900;
    font-size: 1.75rem;
    line-height: 2rem;
  }

  .YT88as1ms5dCjRtxFdpB {
    width: 100%;
    padding: 0;
  }

  .mML8Ohzo58mv5uaARftT {
    width: 100%;
    margin: 2.1875rem 0;
  }

  .qh3Ey0A5HiVagxeeawH3 {
    width: 100%;
    height: 12.625rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/BusinessHeroBlock/BusinessHeroBlock.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,gBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,sBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,oBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,gBAAc;AAChB;;AAEA;EACE,kBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,qBAAgB;AAClB;;AAEA;EACE,eAAY;EACZ,kBAAa;EACb,yCAAyC;EACzC,iBAAiB;EACjB,8CAAuC;AACzC;;AAEA;;;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,kBAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;;;EACE;IACE,2BAAuB;EACzB;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,mBAAe;IACf,qBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,qBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,mBAAc;EAChB;;EAEA;IACE,WAAW;IACX,iBAAa;EACf;AACF;;AAEA;;EACE;IACE,2BAAuB;EACzB;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,kBAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,mBAAc;EAChB;;EAEA;IACE,WAAW;IACX,iBAAa;EACf;AACF","sourcesContent":[".businessHeroBlock {\n  width: 100%;\n  background-color: var(--top-block-background);\n}\n\n.businessHeroBlockInner {\n  max-width: 1440px;\n  padding: 48px 64px;\n  margin: 0 auto;\n}\n\n.content {\n  display: flex;\n}\n\n.leftBlock {\n  width: 50%;\n  padding-right: 100px;\n}\n\n.title {\n  margin-top: 48px;\n  font-weight: 900;\n  font-size: 48px;\n  line-height: 52px;\n}\n\n.subTitle {\n  color: var(--top-block-contrast-font-color);\n  margin: 24px 0;\n}\n\n.buttonsBlock {\n  margin-top: 24px;\n}\n\n.heroImageContainer {\n  width: 50%;\n  margin-top: 55px;\n}\n\n.heroImage {\n  width: 636px;\n  height: 357px;\n  border-radius: var(--panel-border-radius);\n  object-fit: cover;\n  box-shadow: 0 4px 12px var(--black-012);\n}\n\n@media (--desktop-small) {\n  .businessHeroBlockInner {\n    padding: 32px 48px;\n  }\n\n  .heroImage {\n    width: 100%;\n  }\n\n  .title {\n    font-weight: 800;\n    font-size: 28px;\n    line-height: 32px;\n  }\n}\n\n@media (--tablet) {\n  .businessHeroBlockInner {\n    padding: 24px 32px 24px;\n  }\n\n  .content {\n    display: flex;\n    flex-direction: column-reverse;\n  }\n\n  .title {\n    margin-top: 0;\n    font-weight: 900;\n    font-size: 38px;\n    line-height: 42px;\n  }\n\n  .leftBlock {\n    width: 100%;\n    padding: 0;\n    margin-bottom: 24px;\n  }\n\n  .heroImageContainer {\n    width: 100%;\n    margin: 35px 0;\n  }\n\n  .heroImage {\n    width: 100%;\n    height: 302px;\n  }\n}\n\n@media (--mobile) {\n  .businessHeroBlockInner {\n    padding: 24px 16px 24px;\n  }\n\n  .content {\n    display: flex;\n    flex-direction: column-reverse;\n  }\n\n  .title {\n    margin-top: 0;\n    font-weight: 900;\n    font-size: 28px;\n    line-height: 32px;\n  }\n\n  .leftBlock {\n    width: 100%;\n    padding: 0;\n  }\n\n  .heroImageContainer {\n    width: 100%;\n    margin: 35px 0;\n  }\n\n  .heroImage {\n    width: 100%;\n    height: 202px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"businessHeroBlock": `i_wBNb1ia80e7xh5BIcx`,
	"businessHeroBlockInner": `EaDF20f8yg3aath0KQVL`,
	"content": `V_9Dg7Vo_BOLIKJjQaof`,
	"leftBlock": `YT88as1ms5dCjRtxFdpB`,
	"title": `Vc8yfPcUlAejSxUY8Hol`,
	"subTitle": `XdEQwWsSTgWXWA1bGGwC`,
	"buttonsBlock": `SSbXmq1B8F5wSohlzaPV`,
	"heroImageContainer": `mML8Ohzo58mv5uaARftT`,
	"heroImage": `qh3Ey0A5HiVagxeeawH3`
};
export default ___CSS_LOADER_EXPORT___;
